import React from "react";
import Card from "@mui/material/Card";
import {useTranslation} from "react-i18next";

import AclTable from "../../../components/AclTable";
import StationCol from "../../../components/columns/StationCol";


const CardPermissions = ({groupId}) => {
    const {t} = useTranslation(['groups']);

    return <Card sx={{p: 2}}>

        <AclTable title={t('group.cardPermissions.title')}
                  principalType={"group"}
                  principalId={groupId}
                  resourcesType={"station"}
                  permissions={['mod1:write', 'mod23:write']}
                  entityHeader={t('group.cardPermissions.table.station')}
                  renderEntityCol={(station) => <StationCol station={station}/>}
                  multipleCheck
                  entitySortFieldName="code"
        />

    </Card>
}

export default CardPermissions;